// extracted by css-extract-rspack-plugin
export default {"cls1":"MarketingPageLayout-cls1_lFR","cls2":"MarketingPageLayout-cls2_KqA MarketingPageLayout-cls1_lFR"};